module.exports = __webpack_public_path__ + "static/media/akshay.df4bd644.webp";